define(function(require) {
    var _ = require('underscore');
    var i18n = require('i18n');
    var LimitsView = require('portlets/responsible-gaming/limits/limits.view');
    var LimitsPopupView = require('portlets/responsible-gaming/limits/limits.popup.view');

    return LimitsPopupView.extend({
        setOptions: function(options) {
            options = options || {};
            options.data = options.data || {};

            this.options.priority = 'hight';
            this.options.isModal = true;
            this.options.closeAll = false;
            this.options.order = 0;

            _.extend(this.options.data, {
                articleId: 'LOSS_LIMIT_POPUP_CONTENT',
                title: i18n.t('playtech.mobile.system.ngresponsiblegaming.limits.lossLimit.heading'),
                buttons: false,
                content: this.tmpl('limits.popup'),
                limitsCallback: this.close.bind(this),
                updateFromPopup: true
            });

            this.childViews.push(new LimitsView(this.options.data));
        },
    });
});
